import React, { useState, useEffect, useCallback } from 'react';
import axios from '../../../axios';
import {
  Container, Card, CardHeader, CardContent,
  Typography, Box, TextField, MenuItem, Button
} from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import dayjs from 'dayjs';

export default function AggregatedReport() {
  const companyId = parseInt(localStorage.getItem('companyId'), 10);

  const [products, setProducts] = useState([]);
  const [branches, setBranches] = useState([]);
  const [stocks, setStocks] = useState([]);

  const [productId, setProductId] = useState('');
  const [branchId, setBranchId] = useState('');
  const [stockId, setStockId] = useState('');
  const [dateFrom, setDateFrom] = useState(dayjs().subtract(30,'day').format('YYYY-MM-DD'));
  const [dateTo, setDateTo]   = useState(dayjs().format('YYYY-MM-DD'));

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  // جلب قوائم فلترة
  useEffect(() => {
    axios.get(`/Product/by-company/${companyId}`).then(r => setProducts(r.data));
    axios.get(`/Branch/by-company/${companyId}`).then(r => setBranches(r.data));
    axios.get(`/Stock/by-company/${companyId}`).then(r => setStocks(r.data));
  }, [companyId]);

  const fetchReport = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        ...(productId && { productId }),
        ...(branchId && { branchId }),
        ...(stockId && { stockId }),
        dateFrom: `${dateFrom}T00:00:00`,
        dateTo:   `${dateTo}T23:59:59`
      };
      const res = await axios.get(
        `/StockMovements/summary-report/${companyId}`,
        { params }
      );
      // تحويل المفاتيح إلى camelCase
      const data = res.data.map((r, i) => ({
        id: i,
        productName: r.productName,
        branchName:  r.branchName,
        stockName:   r.stockName,
        totalIn:     r.totalIn,
        totalOut:    r.totalOut,
        netMovement: r.netMovement,
        costIn:      r.costIn,
        costOut:     r.costOut
      }));
      setRows(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [companyId, productId, branchId, stockId, dateFrom, dateTo]);

  useEffect(() => { fetchReport(); }, [fetchReport]);

  const columns = [
  { field: 'productName',  headerName: 'الصنف',       flex: 1 },
  { field: 'branchName',   headerName: 'الفرع',       flex: 1 },
  { field: 'stockName',    headerName: 'المستودع',    flex: 1 },
  { field: 'totalIn',      headerName: 'الوارد',      type: 'number' },
  { field: 'totalOut',     headerName: 'الصادر',      type: 'number' },
  { field: 'netMovement',  headerName: 'الصافي',      type: 'number' },
  { 
    field: 'costIn',       
    headerName: 'اجمالي الوارد', 
    type: 'number', 
    width: 120,
    renderCell: (params) => {
      return (params.row.costIn || 0).toFixed(2);
    }
  },
  { 
    field: 'costOut',      
    headerName: 'اجمالي الصادر', 
    type: 'number',
    width: 120, 
    renderCell: (params) => {
      return (params.row.costOut || 0).toFixed(2);
    }
  },
];

  return (
    <Container maxWidth="xl" dir="rtl" sx={{ py: 4 }}>
      <Card>
        <CardHeader title={<Typography>تقرير حركة الأصناف (تجميعي)</Typography>} />
        <CardContent>
          <Box sx={{ mb:2, display:'flex', gap:2, flexWrap:'wrap', alignItems:'center' }}>
            <TextField select label="اختر صنفًا" size="small" value={productId} onChange={e=>setProductId(e.target.value)}  sx={{ width: 200 }}>
              <MenuItem value=""><em>كل الأصناف</em></MenuItem>
              {products.map(p=><MenuItem key={p.id} value={p.id}>{p.arabicName}</MenuItem>)}
            </TextField>
            <TextField select label="اختر فرعًا" size="small" value={branchId} onChange={e=>setBranchId(e.target.value)}  sx={{ width: 200 }}>
              <MenuItem value=""><em>كل الفروع</em></MenuItem>
              {branches.map(b=><MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>)}
            </TextField>
            <TextField select label="اختر مستودعًا" size="small" value={stockId} onChange={e=>setStockId(e.target.value)} sx={{ width: 200 }} >
              <MenuItem value=""><em>كل المستودعات</em></MenuItem>
              {stocks.map(s=><MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
            </TextField>
            <TextField label="من تاريخ" type="date" size="small" value={dateFrom} onChange={e=>setDateFrom(e.target.value)} InputLabelProps={{shrink:true}} />
            <TextField label="إلى تاريخ" type="date" size="small" value={dateTo} onChange={e=>setDateTo(e.target.value)} InputLabelProps={{shrink:true}} />
            <Button variant="contained" onClick={fetchReport}>عرض التقرير</Button>
          </Box>
          <DataGrid
            rows={rows}
            columns={columns}
            loading={loading}
            autoHeight
            components={{ Toolbar: GridToolbar }}
            pageSize={25}
            rowsPerPageOptions={[25,50,100]}
          />
        </CardContent>
      </Card>
    </Container>
  );
}